import React, {useEffect } from "react";
import clsx from "clsx";
import {
  MenuItem,
  Menu,
  ClickAwayListener,
} from "@material-ui/core";
import ServicePopUpWindow from './Services/ServicePopUpWindow';
import DeleteComponentPopUpWindow from './PopUpsValidations/DeleteComponentPopUpWindow';
import DataElelementPopUpWindow from "./DataElements/DataElementPopUpWindow"
import LoadBlocks from './GrapesJs/LoadBlocks/LoadBlocks';

const TableManager = (props) => {

    const { 
        selectedPage,
        selectedProject,
        editor,
        savedPageClicked,
        servicesBlocks,
        setServicesBlocks,
        servicesRequests, 
        setServicesRequests,
     } = props
    const [responseObj, setResponseObj] = React.useState({});
    const [openService, setOpenService] = React.useState(false);
    const [clickedEditBlockService, setClickedEditBlockService] = React.useState(false);
    const [indexEditBlockService, setIndexEditBlockService] = React.useState(-1);
    const [indexEditBlockDataElement, setIndexEditBlockDataElement] = React.useState(-1);
    const [clickedEditBlockDataElement, setClickedEditBlockDataElement] = React.useState(false);
    const [deleteAlertService, setDeleteAlertService] = React.useState(false);
    const [deleteAlertDataElement, setDeleteAlertDataElement] = React.useState(false);
    const [openDataElement,setOpenDataElement] = React.useState(false); 
    const [indexDeleteService, setIndexDeleteService] = React.useState(-1);
    const [indexDeleteDataElement, setIndexDeleteDataElement] = React.useState(-1);
    const [renderAgain, setRenderAgain] = React.useState(false);
    const [stateCreateElement, setStateCreateElement] = React.useState(false);
    const Options = ['new service', 'new data element'];
    const [anchorEl, setAnchorEl] = React.useState();
    const [displayServicesContent, setDisplayServicesContent] = React.useState(false);
    const [displayDataElementsContent, setDisplayDataElementsContent] = React.useState(false);
    const [editDataElementType, setEditDataElementType] = React.useState();
    const [activeViewAnnotations, setActiveViewAnnotations] = React.useState(false);

    useEffect( () => {
      if(renderAgain === true){
        setRenderAgain(false);
      }

    },[renderAgain])

    useEffect(() => {
        
        if(editor.BlockManager !== undefined) {
          LoadBlocks.loadBlocks(editor); 
          if(!editor.Commands.isActive('core:preview')){
            editor.runCommand("sw-visibility");
          }
        }
          
    },[selectedPage, selectedProject]);

    
    const openServicePopUp = () => {
      setOpenService(true);
      setClickedEditBlockService(false);
    }

    const openDataElementPopUp = () => {
      setOpenDataElement(true);
      setClickedEditBlockDataElement(false);
    }

    const editBlockService = (indexBlock) => {
      setIndexEditBlockService(indexBlock);
      setClickedEditBlockService(true);
      setOpenService(true);

    }

    const editBlockDataElement = (indexBlock) => {
      setOpenDataElement(true);
      setIndexEditBlockDataElement(indexBlock);
      setClickedEditBlockDataElement(true);
      const tempDataType = JSON.parse(localStorage.getItem('data'))[selectedProject].data_elements.data_elements_info[indexBlock].type;
      setEditDataElementType(tempDataType);
    }

    const deleteBlockService = (indexBlock) => {
      
      const tempServicesBlocks = [...servicesBlocks];
      const tempServicesRequests = [...servicesRequests];
      
      if(editor.BlockManager !== undefined && servicesBlocks[selectedProject][indexBlock] !== undefined){
        editor.BlockManager.remove(servicesBlocks[selectedProject][indexBlock].id);
      }

      tempServicesBlocks[selectedProject].splice(indexBlock,1);
      tempServicesRequests[selectedProject].splice(indexBlock,1)

      setServicesBlocks(tempServicesBlocks);
      setServicesRequests(tempServicesRequests);

      const tempProjects = JSON.parse(localStorage.getItem("data")); 
      tempProjects[selectedProject].services = [];
      const tempServices = {services_blocks: tempServicesBlocks[selectedProject],services_requests : tempServicesRequests[selectedProject]};
      tempProjects[selectedProject].services.push(tempServices);
      localStorage.setItem('data',JSON.stringify(tempProjects));
      savedPageClicked();

      setDeleteAlertService(false);
    }

    const handleDeleteBlockService = (indexBlock) => {
      setDeleteAlertService(true);
      setIndexDeleteService(indexBlock);
     
    }

    const handleDeleteBlockDataElement = (indexBlock) => {
      setDeleteAlertDataElement(true);
      setIndexDeleteDataElement(indexBlock);
    }

    const closeDeleteAlertService =() => {
      setDeleteAlertService(false);
      setIndexDeleteService(false);
      setIndexDeleteService(-1);
    }

    const closeDeleteAlertDataElement = () => {
      setDeleteAlertDataElement(false);
      setIndexDeleteDataElement(false);
      setIndexDeleteDataElement(-1);
    }
    
    const deleteBlockDataElement = (indexBlock) => {
        const tempData = JSON.parse(localStorage.getItem('data'));
        
        if(editor.BlockManager !== undefined && tempData[selectedProject].data_elements.data_elements_blocks[indexBlock] !== undefined){
          tempData[selectedProject].data_elements.data_elements_blocks[indexBlock].blocks.forEach( (block) => {
            editor.BlockManager.remove(block.id);  
          })
        
        }

        tempData[selectedProject].data_elements.data_elements_blocks.splice(indexBlock, 1);
        tempData[selectedProject].data_elements.data_elements_info.splice(indexBlock,1);
        localStorage.setItem('data',JSON.stringify(tempData));
        savedPageClicked();
        setRenderAgain(true);
        setDeleteAlertDataElement(false);

    }

    const changeStateMethod = (event) => {
        setStateCreateElement(true);
        setAnchorEl(event.currentTarget);
    }

    const closeMenu = () => {
        setStateCreateElement(false);
        setAnchorEl(null);
    }

    const selectMethod = (option) => {
      if(option === 'new service'){
        openServicePopUp();
      }
      else{
        openDataElementPopUp();
      }
    } 

    const changeDisplayServicesContent = () => {
      setDisplayServicesContent(!displayServicesContent);
    }

    const changeDisplayDataElementsContent = () => {
      setDisplayDataElementsContent(!displayDataElementsContent);
    }


    
    if(editor.BlockManager !== undefined){
      editor.on('run:view-annotations', () => {
        setActiveViewAnnotations(true);
      })
      editor.on('stop:view-annotations',() => {
        setActiveViewAnnotations(false);
      })
    }
  

    return (
        <>
          <div 
            style={{ width:'inherit' }} 
            className={clsx( "flexProps2", 'overflowAuto')} >
                <div className={clsx("panel__switcher")} />
                <div style={{ flex: '0 1 100%', 
                  height: '100%'}}
                  className={clsx("blueTableStyle2", 'flexProps2', 'overflow-style','overflowAuto')}
                >
                  <div >
                    <div  className= "blocks-container" />
                    <div
                      className="styles-container"
                      style={{ display: 'none' }}
                    />
                  <div 
                    className = "data-container"
                    style={{display: 'none', marginTop: "0.5vw"}}
                  >   
                    <div className={clsx('spacingLeftDiv')}>
                      <div className={clsx('flexRowDirection', 'white')}>
                        <div className={clsx('fa', 'fa-plus', 'fa-plus2')}> </div>
                        <div style={{ fontSize: '1.2vw'}} > Create &nbsp;</div>
                        <div 
                            className={clsx('teamSelector' ,'styleDropDown')} 
                            onClick={(event) => changeStateMethod(event)}
                            aria-hidden="true"
                            >
                              <span > &nbsp;new service</span> 
                              {stateCreateElement === false ? 
                                    
                                    <span className={clsx('fa', 'fa-caret-down', 'fa-caret-down4','teamSelector',)}> </span>
                                    : 
                                    <ClickAwayListener 
                                        onClickAway ={closeMenu}
                                    >
                                        <span className={clsx('fa', 'fa-caret-up','fa-caret-up4', 'teamSelector')} />
                                    </ClickAwayListener>
                                }
                        </div>
                        <Menu   
                            elevation={0}
                            getContentAnchorEl={null}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            anchorEl={anchorEl}
                            keepMounted
                            open={stateCreateElement}
                            >
                                {
                                    Options.map((option) => (
                                        <MenuItem 
                                            key={option}
                                              onClick ={() => selectMethod(option)}
                                            > 
                                            {option}
                                        </MenuItem>
                                    ))
                                }
                        </Menu>
                      </div>
                    </div>
                    <div className={clsx('bottomBorder1')}>
                      <div className={clsx('flexRowDirection','teamSelector', 'spacingLeftDiv2','spacingTopDiv', )} onClick ={changeDisplayServicesContent} aria-hidden="true">     
                          <i id="gjs-sm-caret"  
                              className={displayServicesContent === true ?clsx('fa' ,'fa-caret-down ') : clsx('fa','fa-caret-right')}
                          aria-hidden="true"/>
                          <div className ={clsx('white')} > &nbsp; &nbsp;Services wrappers </div>
                      </div>
                    </div>
                    <div className ={clsx('spacingLeftDiv2')}>
                      { selectedProject > -1  && displayServicesContent === true?
                            <ul>
                              {
                                servicesRequests[selectedProject].map( (serviceRequest, index) => 
                                  <li
                                    key= {serviceRequest.name}
                                    className ={clsx( 'white','spacingTopDiv','spacingLeft')}
                                  >
                                      <span> {serviceRequest.name} &nbsp;</span>
                                      <img display='flex' src='/images/General/Grey_edit.png'  onClick={() => editBlockService(index)} aria-hidden="true" alt="black_edit_logo"  style={{ marginRight: '1vw' }} className={clsx('functionsLogoStyle', 'teamSelector')} />
                                      <img display='flex' src='/images/General/Grey_delete.png' onClick={() => handleDeleteBlockService(index)} aria-hidden="true" alt="black_delete_logo"  style={{ marginRight: '1vw' }} className={clsx('functionsLogoStyle', 'teamSelector')} />
                                  </li>
                                )
                              }
                            </ul>
                            :
                            null
                          }
                    </div>        
                    <div className={clsx('bottomBorder1')}>
                      <div className={clsx('flexRowDirection','teamSelector', 'spacingLeftDiv2','spacingTopDiv', )} aria-hidden="true" onClick ={changeDisplayDataElementsContent}>
                              
                              <i id="gjs-sm-caret"  
                                  className={displayDataElementsContent === true ?clsx('fa', 'fa-caret-down ') : clsx('fa', 'fa-caret-right')}
                              aria-hidden="true"/>
                              <div className ={clsx('white')} > &nbsp; &nbsp;Data elements wrappers</div>
                          </div>
                    </div>
                    <div className ={clsx('spacingLeftDiv2')}>
                      {selectedProject > -1 && displayDataElementsContent === true?
                          <ul>
                            {JSON.parse(localStorage.getItem('data'))[selectedProject].data_elements.data_elements_info.map( (data_element,index) =>
                              <li
                                key ={data_element.dataName}
                                className ={clsx('white', 'spacingTopDiv','spacingLeft')}
                              >
                                <span> {data_element.dataName} &nbsp; </span>
                                <img display='flex' src='/images/General/Grey_edit.png'   alt="grey_edit_logo" aria-hidden="true" onClick={() => editBlockDataElement(index)} style={{ marginRight: '1vw' }} className={clsx('functionsLogoStyle', 'teamSelector')} />                                
                                <img display='flex' src='/images/General/Grey_delete.png'  alt="grey_delete_logo" aria-hidden="true" onClick={() =>handleDeleteBlockDataElement(index)} style={{ marginRight: '1vw' }} className={clsx('functionsLogoStyle', 'teamSelector')} />
                              </li>
                            )
                            }
                          </ul>
                          :
                          null

                        }
                    </div>  
                  </div>
                  <div
                    className = 'layer-container' style={{display: 'none',marginTop: '0.5vw', flex:'1 0 100%'}}
                  />
                </div>
            </div>       
          </div> 
          { activeViewAnnotations &&
                  <div style={{position: 'absolute', height: '100%', width: 'inherit', backgroundColor: '#12416b',opacity: '0.75',zIndex: '10'}}/>
                }
          <ServicePopUpWindow
            openAlert={openService}
            setOpenAlert={setOpenService}
            responseObj={responseObj}
            setResponseObj={setResponseObj}
            editor={editor}
            servicesBlocks={servicesBlocks}
            setServicesBlocks={setServicesBlocks}
            selectedProject={selectedProject}
            servicesRequests={servicesRequests}
            setServicesRequests={setServicesRequests}
            clickedEditBlockService={clickedEditBlockService}
            setClickedEditBlockService={setClickedEditBlockService}
            indexEditBlockService={indexEditBlockService}
            setIndexEditBlockService={setIndexEditBlockService}
            savedPageClicked={savedPageClicked}
          />
          <DeleteComponentPopUpWindow 
            handleClose={closeDeleteAlertService}
            confirmDeleteComponent={() => deleteBlockService(indexDeleteService)}
            open={deleteAlertService}
            setOpen={setDeleteAlertService}
            component='service'
          />
          <DeleteComponentPopUpWindow
            handleClose={closeDeleteAlertDataElement}
            confirmDeleteComponent={() => deleteBlockDataElement(indexDeleteDataElement)}
            open={deleteAlertDataElement}
            component='data element'
            setOpen={setDeleteAlertDataElement}             
          />
          
          <DataElelementPopUpWindow
            openAlert={openDataElement}
            setOpenAlert={setOpenDataElement}
            editor={editor}
            selectedProject={selectedProject}
            indexEditBlockDataElement={indexEditBlockDataElement}
            setIndexEditBlockDataElement={setIndexEditBlockDataElement}
            clickedEditBlockDataElement={clickedEditBlockDataElement}
            setClickedEditBlockDataElement={setClickedEditBlockDataElement}
            editDataElementType={editDataElementType}
            setRenderAgain={setRenderAgain}
            savedPageClicked={savedPageClicked}
          />
        </>
    );
}

export default TableManager;